import { localeToISO639Code } from "lib/i18n/localeToISO639Code";
import { SunburnFrequency } from "lib/questionnaire/question-flows/onboarding/questions/sunburn";
import { Trans as TransQuestions } from "lib/questionnaire/question-flows/onboarding/questions/trans";
import { useLocale } from "render/context/InternationalizationContext";
import { ChoiceInput } from "render/ui/presentation/Questionnaire/components/ChoiceInput";
import { QuestionView } from "../../components/QuestionView";
import { Step, StepProps } from "../../step";
import { Trans } from "../../trans";

function SunburnStep({
  answers,
  onAnswer,
  onNext,
  onPrev,
  currentQuestion,
  totalQuestions,
  onResetAnswer,
}: StepProps) {
  const answer = answers.get(SunburnFrequency);
  const label = TransQuestions.Sunburn.Question();
  const { englishLabel } = TransQuestions.Sunburn.Question;
  const locale = useLocale();
  const languageCode = localeToISO639Code(locale);

  return (
    <QuestionView
      currentQuestion={currentQuestion}
      totalQuestionCount={totalQuestions}
      question={SunburnFrequency}
      onNext={() => {
        onResetAnswer(SunburnFrequency);
        onNext();
      }}
      onPrev={() => {
        onPrev();
        onResetAnswer(SunburnFrequency);
      }}
      explanation={{
        openText: <Trans.Steps.SunburnOpenText />,
        closeText: <Trans.General.OkIUnderstand />,
        explanationText: <Trans.Steps.SunburnExplanation />,
      }}
    >
      <ChoiceInput
        question={SunburnFrequency}
        answer={answer}
        onAnswer={(answer) => {
          onAnswer(SunburnFrequency, {
            answer,
            questionAnswer: {
              questionId: "sunburn",
              englishLabel,
              label,
              languageCode,
              answer: {
                $type: "stringenum",
                value: SunburnFrequency.getValue(answer) || "",
              },
            },
          });
          onNext();
        }}
      />
    </QuestionView>
  );
}

export function filter(steps: Step[]) {
  steps.push(SunburnStep);
}
